import React, { useEffect } from 'react';
import PageTemplate from 'template/PageTemplate';
import { Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import CourseForm from '../Form';
import { createUserRequest } from '../../../../services/user';
import useFetch from '../../../../hooks/useFetch';
import { Metrics } from '../../../../configs';
import TopicForm from '../Form';
import TrainingForm from '../Form';

const BackofficeTrainingCreate = () => {
  const history = useHistory();
  const { goBack } = history;
  const initialValues = {
    document: '',
    email: '',
    name: '',
    phone: '',
    password: '',
  };
  const [{ isFetching, data }, createUser] = useFetch(
    createUserRequest,
    '',
    false,
    null
  );

  useEffect(() => {
    if (data) {
      history.goBack();
    }
  }, [history, data]);

  return (
    <PageTemplate title="Criação de Treinamento">
      <Spin spinning={isFetching}>
        <TrainingForm
          initialValues={initialValues}
          handleSubmitForm={createUser}
          handleCancel={goBack}
        />
      </Spin>
    </PageTemplate>
  );
};

export default BackofficeTrainingCreate;
